module.exports = __webpack_public_path__ + "img/article_c.ef06e4ff.png";